import BaseInput from './base-input'

export default {
    install: function(Vue) {
        Vue.component('BaseInput', BaseInput)
    }
}